import IComponent from "components/commons/IComponent";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import ReactECharts from "echarts-for-react";
import "./GroundProfile.scoped.css";
import "./PanelBase.scoped.css";
import geometryTools from "utils/geometryTools";

class GroundProfileAGS extends IComponent {
  eChartRef = null;
  constructor(props) {
    super(props);
    this.state = {
      outputTable: [],
      GIonLine: [],
      isLoading: true,
      AccumulatedGroundSegment: [],
    };
  }

  componentDidMount() {
    this.ProcessGroundProfile();
    this.props.mapUICallback("DisaleAllWhenShowPanel");
  }
  componentWillUnmount() {}
  async ProcessGroundProfile() {
    try {
      let cutLineSymbol = { ...geometryTools.highlightSymbol.polyline };
      cutLineSymbol.width = 1;
      cutLineSymbol.color = [255, 0, 0, 1];
      let pointSymbol = { ...geometryTools.highlightSymbol.point };
      pointSymbol.size = 4;
      pointSymbol.outline = { width: 0 };
      pointSymbol.color = [255, 0, 0, 1];

      this.setState({ isLoading: true });

      let url = this.$config.gpToolUrls.AGS;
      let GP_url = this.$config.gpToolUrls.ProjectGroundProfile;
      let GP_params = this.props.params[0];
      let AGS_params = this.props.params[1];
      let options = {
        userProxy: this.$config.useEsriProxy,
      };

      let GP_processR = undefined;
      let GIonLine = [];
      let outputTable = [];

      let GroundSegment = await this.props.params[2];
      var AccumulatedGroundSegment = [];
      if (GroundSegment.length > 1) {
        var accumulatedValue = 0;
        GroundSegment.forEach((element) => {
          accumulatedValue += Math.round(element);
          AccumulatedGroundSegment.push(accumulatedValue);
        });
      }
      let updatedAGSParams = {
        f: "json",
        env: { outSR: 2326 },
        Buffer_Distance: AGS_params.Buffer_Distance,
        DrawLine: {
          f: "json",
          "env:outSR": 2326,
          geometryType: "esriGeometryPolyline",
          features: [
            {
              geometry: {
                paths: geometryTools.finetunePolyline(
                  AGS_params.DrawLine.features[0].geometry.paths
                ),
                spatialReference: {
                  wkid: 2326,
                },
              },
            },
          ],
          sr: { wkid: 2326 },
        },
      };
      // GIonLine
      let GP_Result = await geoprocessor.submitJob(
        url,
        updatedAGSParams,
        undefined,
        options
      );

      let updatedGPParams = {
        f: "json",
        "env:outSR": 2326,
        Buffer_Distance: GP_params.Buffer_Distance,
        DrawLine: {
          geometryType: "esriGeometryPolyline",
          features: [
            {
              geometry: {
                paths: geometryTools.finetunePolyline(
                  GP_params.DrawLine.features[0].geometry.paths
                ),
                spatialReference: {
                  wkid: 2326,
                },
              },
            },
          ],
          sr: { wkid: 2326 },
        },
      };
      // output table
      let processR = await geoprocessor.submitJob(
        GP_url,
        updatedGPParams,
        undefined,
        options
      );

      // cancel arcgis job purpose
      this.setState({
        outputTable: GP_Result,
        GIonLine: processR,
      });

      let PR = await processR.waitForJobCompletion();
      outputTable = await PR.fetchResultData("outputTable");
      GP_processR = await GP_Result.waitForJobCompletion();
      GIonLine = await GP_processR.fetchResultData("GIonLine");

      let outputLine = await PR.fetchResultData("outputPoint");
      let mapPoint = outputLine.value.features.map(
        (i) => new geometryTools.Point(i.geometry)
      );
      let lineGraphic = new geometryTools.Graphic({
        symbol: cutLineSymbol,
        geometry: this.props.params[0].DrawLine.features[0].geometry,
      });
      let pointGraphics = mapPoint.map(
        (i) =>
          new geometryTools.Graphic({
            symbol: pointSymbol,
            geometry: i,
          })
      );
      console.debug(lineGraphic, pointGraphics);
      this.props.mapView.graphics.add(lineGraphic);
      this.props.mapView.graphics.addMany(pointGraphics);

      outputTable =
        outputTable.value.features.length === 0
          ? []
          : outputTable.value.features;

      GIonLine =
        GIonLine.value.features.length === 0 ? [] : GIonLine.value.features;

      // console.log(outputTable, GIonLine);

      (GIonLine.length === 0 &&
        this.props.showDialog({
          isOpen: true,
          type: "error",
          title: "No AGS data within buffer !",
          content: "No AGS data within buffer !",
          onDialogOk: () => {},
        })) ||
        this.props.showDialog();

      this.setState(
        {
          outputTable: outputTable,
          GIonLine: GIonLine,
          AccumulatedGroundSegment: AccumulatedGroundSegment,
          isLoading: false,
        }
        // () => {
        //   this.props.resizeWindow(null, true);
        //   this.echartRef.resize();
        // }
      );
    } catch (e) {
      this.props.mapUICallback("hideAllPanel");
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Failed to submit your Ground Profile with AGS data",
        content:
          "Error occurred when submiting your Ground Profile with AGS data",
        jsxElement: e.toString(),
        onDialogOk: () => {},
      });
    }
  }

  SetofData(data2) {
    let array = data2.map((i) => [
      i.attributes.x,
      i.attributes.GL - i.attributes.top,
      i.attributes.Statno +
        "(" +
        (Math.ceil(i.attributes.Prjdist * 10) / 10).toFixed(1) +
        ")",
    ]);

    const groupedArray = array.reduce((result, current) => {
      const category = current[2];

      if (!result[category] || current[1] > result[category][1]) {
        result[category] = current;
      }

      return result;
    }, {});

    return groupedArray;
  }

  getChartOptions(title, data, data2, data3 = []) {
    let minX = Math.min(
      Math.min.apply(null, data.map((i) => i.attributes.x)),
      Math.min.apply(null, data2.map((i) => i.attributes.x))
    );
    let AccumulatedGroundSegmentLength =
      this.state.AccumulatedGroundSegment.length > 1
        ? Math.max.apply(
            null,
            // data3.map((i) => [i, Math.ceil(FinalV / 10) * 10]).flat()
            data3
          )
        : -1;
    // data
    let maxAxisValue = Math.max(
      Math.max.apply(null, data.map((i) => i.attributes.x)),
      Math.max.apply(null, data.map((i) => i.attributes.y)) -
        Math.min.apply(null, data.map((i) => i.attributes.y)),
      Math.max.apply(null, data2.map((i) => i.attributes.x)),
      Math.max.apply(
        null,
        data2.map(
          (i) =>
            i.attributes.GL -
            i.attributes.top -
            (i.attributes.GL - i.attributes.bottom)
        )
      ),
      AccumulatedGroundSegmentLength
    );
    // maxAxisValue = maxAxisValue + (50 - (maxAxisValue % 50));

    let minY = Math.min(
      Math.min.apply(null, data.map((i) => i.attributes.y)), // data Y
      Math.min.apply(
        null,
        data2.map((i) => i.attributes.GL - i.attributes.bottom) //data2 Y
      ),
      Math.min.apply(
        null,
        data2.map((i) => i.attributes.GL - i.attributes.bottom) //data2 Y
      )
    );

    // let xSpread = Math.max(
    //   Math.max.apply(null, data.map((i) => i.attributes.x)) - 0,
    //   Math.max.apply(
    //     null,
    //     data2.map(
    //       (i) => i.attributes.x // x
    //     )
    //   ) - 0
    // );

    // let ySpread = Math.max(
    //   Math.max.apply(null, data.map((i) => i.attributes.y)) -
    //     Math.min.apply(null, data.map((i) => i.attributes.y)),
    //   Math.max.apply(
    //     null,
    //     data2.map(
    //       (i) =>
    //         i.attributes.GL -
    //         i.attributes.top -
    //         (i.attributes.GL - i.attributes.bottom)
    //     )
    //   ) -
    //     Math.min.apply(
    //       null,
    //       data2.map(
    //         (i) =>
    //           i.attributes.GL -
    //           i.attributes.top -
    //           (i.attributes.GL - i.attributes.bottom)
    //       )
    //     )
    // );

    // let largerX = xSpread > ySpread ? true:false;

    // let data2_minY = Math.min.apply(null, data.map((i)=> i.attributes.y));

    // const labelname = [];

    const BAR_WIDTH = 0.5;

    const setofData = Object.entries(this.SetofData(data2)).map(
      ([key, value]) => {
        // labelname = value[2];
        return [value[0] + BAR_WIDTH / 2, value[1], value[2]];
      }
    );

    console.log("setofData", setofData);

    // _ground_data = data;
    // console.log(_ground_data);
    // const colorList = [
    //   "#4f81bd",
    //   "#c0504d",
    //   "#9bbb59",
    //   "#604a7b",
    //   "#948a54",
    //   "#e46c0b",
    // ];
    const colorList = [
      "rgba(79, 129, 189, 0.7)", // #4f81bd with 50% transparency
      "rgba(192, 80, 77, 0.7)", // #c0504d with 50% transparency
      "rgba(155, 187, 89, 0.7)", // #9bbb59 with 50% transparency
      "rgba(96, 74, 123, 0.7)", // #604a7b with 50% transparency
      "rgba(148, 138, 84, 0.7)", // #948a54 with 50% transparency
      "rgba(228, 108, 11, 0.7)", // #e46c0b with 50% transparency
    ];

    // x, ?, value, category, y
    const AGSdata = data2
      .map((i) => [
        i.attributes.x, // x
        0,
        i.attributes.GL - i.attributes.top, // y
        i.attributes.Geology,
        i.attributes.GL - i.attributes.bottom, //y
      ])
      .map(function(item, index) {
        return {
          value: item,
          itemStyle: {
            // color: colorList[index % colorList.length],
            color: colorList[Math.floor(Math.random() * 6)],
          },
        };
      })
      .reverse();

    console.log("check AGSdata", AGSdata);

    const CHART_OPTIONS = {
      //   title: {
      //     left: "center",
      //   },
      grid: {
        top: 10,
        right: 30,
      },
      tooltip: {
        show: true,

        trigger: "axis",

        formatter: "{c}<br/>{b}",
      },
      // grid: {
      //   aspectRatio: 1, // Set the aspect ratio of the grid (x-axis length divided by y-axis length)
      // },

      xAxis:
        this.GIonLine?.length > 0
          ? {
              type: "value",
              name: "Distance (m)",
              nameLocation: "middle",
              nameTextStyle: { lineHeight: 56 },
              min: 0,
              max: Math.ceil(maxAxisValue / 10) * 10, // maxAxisValue,
              minInterval: 1,
              interval: 10,
            }
          : {
              type: "value",
              name: "Distance (m)",
              nameLocation: "middle",
              nameTextStyle: { lineHeight: 56 },
              min: 0,
              max: Math.ceil(maxAxisValue / 10) * 10,
              minInterval: 1,
            },

      yAxis:
        this.GIonLine?.length > 0
          ? {
              type: "value",
              name: "Elevation (mPD)",
              nameLocation: "middle",
              nameTextStyle: { lineHeight: 56 },
              min: Math.floor(minY / 10) * 10, //0,
              max:
                Math.floor(minY / 10) * 10 + Math.ceil(maxAxisValue / 10) * 10, // maxAxisValue,
              minInterval: 1,
              interval: 1,
            }
          : {
              type: "value",
              name: "Elevation (mPD)",
              nameLocation: "middle",
              nameTextStyle: { lineHeight: 56 },
              min: Math.floor(minY / 10) * 10, //0,
              max:
                Math.floor(minY / 10) * 10 + Math.ceil(maxAxisValue / 10) * 10,
              minInterval: 1,
              // interval: 1,
            },

      series:
        // this.props.GIBuffer && this.state.GIonLine.length > 0
        //   ?
        [
          {
            data: [],
            type: "line",
            itemStyle: {
              color: "#FF0000",
            },
          },
          {
            type: "custom",
            clip: true,
            renderItem: function(params, api) {
              var yValue = api.value(2);
              // console.log("yValue", yValue);
              var start = api.coord([api.value(0), yValue]);
              console.log("yValue", start);
              var size = api.size([BAR_WIDTH, api.value(2) - api.value(4)]);

              console.log("chcek size", size);
              var style = api.style();
              return {
                type: "rect",
                shape: {
                  x: start[0],
                  y: start[1],
                  width: size[0],
                  height: size[1],
                },
                style: style,
              };
            },
            label: {
              show: true,
              position: "right",
              formatter: function(params) {
                console.log("check params", params.data.value[3]);
                return params.data.value[3];
              },
            },
            encode: {
              x: [0, 1],
              y: 2,
              tooltip: [0, 1, 2],
              itemName: 3,
            },
            data: AGSdata,
          },
          {
            type: "scatter", // Use scatter series type for points
            data: setofData,
            symbol: "triangle", // Set the symbol type for points (e.g., 'circle', 'rect', 'triangle', etc.)
            symbolSize: 5, // Set the size of the symbols (points)
            label: {
              show: true, // Enable data labels
              formatter: "{@[2]}", // Format the label text using the third data value
              position: "top",
              color: "blue",
              margin: 20,
            },
          },
          {
            data: [],
            type: "bar",
            barWidth: 1, // Set the bar width to 1
            itemStyle: {
              color: "#7CFC00",
            },
          },
        ],
      dataZoom: [
        {
          type: "inside", // Enable zooming functionality
          xAxisIndex: 0, // Specify the x-axis index, if there are multiple x-axes
          start: 0, // Set the zoom start position as a percentage (e.g., 20%)
          end: 100, // Set the zoom end position as a percentage (e.g., 80%)
          filterMode: "none", // This ensures that data outside the range is not displayed
        },
        {
          type: "inside", // Enable zooming functionality
          yAxisIndex: 0, // Specify the y-axis index, if there are multiple y-axes
          start: 0, // Set the zoom start position as a percentage (e.g., 30%)
          end: 100, // Set the zoom end position as a percentage (e.g., 70%)
          filterMode: "none",
        },
      ],
    };

    let options = CHART_OPTIONS;
    options.xAxis.data = this.state.outputTable;
    options.series[0].data = data.map((i) => [i.attributes.x, i.attributes.y]);
    options.series[0].symbol = "none";

    options.series[3].data =
      this.state.AccumulatedGroundSegment.length > 1
        ? //data3.map((i) => [i, Math.ceil(FinalV / 10) * 10])
          data3.map((i) => [
            i,
            Math.floor(this.minV(data2, data) / 10) * 10 +
              (Math.ceil(maxAxisValue / 10) * 10 - Math.floor(minX / 10) * 10),
          ])
        : [];
    return options;
  }

  minV(data2, data) {
    let MinGLineLength =
      this.props.GIBuffer && this.state.GIonLine.length > 0
        ? Math.min(
            ...data2.map(
              (i) =>
                parseFloat(i.attributes.GRDLEVEL) -
                parseFloat(i.attributes.DEPTH)
            )
          )
        : 99999;
    let minSegmentLength = Math.min(...data.map((i) => i.attributes.y));
    let FinalV =
      this.props.GIBuffer && this.state.GIonLine.length > 0
        ? minSegmentLength < MinGLineLength
          ? minSegmentLength
          : MinGLineLength
        : minSegmentLength;

    // console.log(MinGLineLength, minSegmentLength);

    return FinalV * 0.9; // adjust Value
  }

  render() {
    let {
      outputTable,
      GIonLine,
      AccumulatedGroundSegment,
      isLoading,
    } = this.state;
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Ground Profile with AGS section</span>
          <div />
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={async () => {
              this.props.mapUICallback("hideAllPanel");

              isLoading && (await outputTable.cancelJob(outputTable.jobId));
              isLoading && (await GIonLine.cancelJob(GIonLine.jobId));
            }}
          />
        </div>
        <div className="ChartsContainer">
          {isLoading && (
            <div className="SubPanelContent">
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                <span className="icn_loading" /> Refreshing your charts...
              </div>
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                }}
              >
                ***Close the window to cancel process***
              </div>
            </div>
          )}
          <div style={{ height: "100%" }}>
            {outputTable.length <= 0 && GIonLine.length <= 0
              ? !isLoading && (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "10px",
                    }}
                  >
                    No data
                  </div>
                )
              : !isLoading && (
                  <ReactECharts
                    ref={(e) => {
                      if (!this.echartRef) {
                        this.echartRef = e;
                      }
                    }}
                    style={{
                      height: "100%",
                      zoom: "125%",
                      aspectRatio: "590 / 580",
                    }}
                    option={this.getChartOptions(
                      "",
                      outputTable,
                      GIonLine,
                      AccumulatedGroundSegment
                    )}
                    autoResize={true}
                  />
                )}
          </div>
        </div>
      </div>
    );
  }
}

export default GroundProfileAGS;
